import { render, staticRenderFns } from "./SystemFooter.vue?vue&type=template&id=6b2b366a&scoped=true"
import script from "./SystemFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./SystemFooter.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2b366a",
  null
  
)

export default component.exports